<div id="htmlData" #htmlData="">
<div *ngFor="let data of pdfData">

    <span class="heading"><strong> {{data.file_number}}. {{data.file_name}}</strong></span>
    <table class="table-striped">
        <thead>
            <tr>
                <th *ngFor="let column of data.table.data[0] | keyvalue ">{{column.key}}</th>
            </tr>

        </thead>
        <tbody>
            <ng-container *ngFor="let row of data.table.data ">
                <tr >
                    <ng-container *ngFor="let value of row | keyvalue">
                        <td>{{ value.value }}</td>
                    </ng-container>
                </tr>
            </ng-container>

        </tbody>
    </table>


</div>
</div>